export const environment = {
  production: false,
  apiUrl: 'https://multi-tenant-auth-729894781313.asia-south1.run.app',
  appVersion: '1.2',  // Auto-synced from build.gradle by scripts/sync-version.js
  uiBuild: 1          // Increment on every frontend-only deploy
};
